export default __webpack_public_path__ + "static/LeituraDisplayTwo-Italic-fe321a8beea8d1c76c11ff1428b68a44.woff";